import React from 'react'

import { theme } from '../../theme'
import { SIconSpan } from '../../../common/styles/Icons'

interface IInfoIconProps extends React.HTMLProps<HTMLSpanElement> {
    className?: string
    fill?: string
    size?: number
    title?: string
    id?: string
    onMouseEnter?: () => void
    onMouseLeave?: () => void
}

export function InfoIcon({
    fill = theme.brandColors.CA_Blue,
    size = 14,
    title,
    id = 'info-icon',
    ...props
}: IInfoIconProps): React.ReactElement {
    return (
        <SIconSpan title={title} id={id} size={size} {...props}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 25 25"
                version="1.1"
                id="svg4"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs id="defs8" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill={fill}
                    id="path2"
                    d="M 12.330078 3.2519531 C 9.9732911 3.2950431 7.7233277 4.2357541 6.0371094 5.8828125 C 4.3509011 7.5298709 3.3562524 9.7581837 3.2578125 12.113281 C 3.1593726 14.468379 3.964934 16.772689 5.5078125 18.554688 C 7.050691 20.336686 9.2155898 21.461572 11.560547 21.701172 C 13.905445 21.940772 16.251549 21.276849 18.123047 19.84375 C 19.994445 18.410551 21.249007 16.316532 21.628906 13.990234 C 22.001706 11.707637 21.506386 9.3705381 20.242188 7.4375 L 20.072266 7.1796875 L 18.966797 8.2871094 L 19.072266 8.4550781 C 20.043765 10.009686 20.427184 11.864396 20.146484 13.683594 C 19.848685 15.614092 18.825755 17.359648 17.285156 18.560547 C 15.744558 19.761446 13.80232 20.326931 11.857422 20.144531 C 9.9125944 19.962031 8.1107712 19.044524 6.8203125 17.578125 C 5.5298538 16.111626 4.8477226 14.208057 4.9140625 12.255859 C 4.9803924 10.303581 5.7907158 8.4496674 7.1777344 7.0742188 C 8.564753 5.6987701 10.424255 4.9054487 12.376953 4.8554688 C 13.739852 4.8205888 15.076207 5.1499725 16.253906 5.7949219 L 16.417969 5.8847656 L 17.556641 4.7480469 L 17.283203 4.5820312 C 15.801205 3.6868621 14.085076 3.2198632 12.330078 3.2519531 z M 11.5 7.5 L 11.5 9.5 L 13.5 9.5 L 13.5 7.5 L 11.5 7.5 z M 11.5 11 L 11.5 17.5 L 13.5 17.5 L 13.5 11 L 11.5 11 z "
                />
            </svg>
        </SIconSpan>
    )
}

export default InfoIcon
